/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 * Returns List of Toy Reviews
 * Alfapeople -Customisation object -For Toy Reviews page
 */

import React, { Component } from 'react';

export interface IToy {
  toyImage?: string;
  toyDescription?: string;
  toyLink?: string;
}
/**
 *
 * ToyReviewList component
 * @extends Component
 */
export class ToyReviewList extends Component {
  private readonly toys: IToy[] = [
    {
      toyImage:
        'https://images-eu-prod.cms.commerce.dynamics.com/cms/api/fnqzbfjwxg/imageFileData/MDjt0',
      toyDescription: 'L.O.L. Surprise OMG Doll',
      toyLink: '/l-o-l-surprise---omg-doll-core-asst/5637323833.p',
    },
    {
      toyImage:
        'https://images-eu-prod.cms.commerce.dynamics.com/cms/api/fnqzbfjwxg/imageFileData/MDjsT',
      toyDescription: 'Poopsie Rainbow Surprise Doll',
      toyLink: '/online/poopsie-rainbow-surprise-doll-assortment-1/5637321605.p',
    },
    {
      toyImage:
        'https://images-eu-prod.cms.commerce.dynamics.com/cms/api/fnqzbfjwxg/imageFileData/MDq1c',
      toyDescription: 'Kindi Kids',
      toyLink: '/kindikids-s1-toddler-doll-sgl-pk---snack-time-fun-jessicake/5637309597.p',
    },
    {
      toyImage:
        'https://images-eu-prod.cms.commerce.dynamics.com/cms/api/fnqzbfjwxg/imageFileData/MDjsW',
      toyDescription: 'Boppi ‘The Booty Shakin’ Llama',
      toyLink: '/boppie-the-booty-shakin-llama-by-zuru/5637307678.p',
    },
  ];
  public render(): JSX.Element | null {
    return (
      <React.Fragment>
        <div className='row'>
          <div className='col-lg-12 col-md-12 col-sm-12'>
            <h1 className='toy-heading'>toy reviews</h1>
          </div>
          {this.toys.map((p) => (
            <div className='col-lg-4 col-md-6 col-sm-12'>
              <div className='row product-row'>
                <div className='col-lg-12 col-md-12 col-sm-6 col-xs-6 product-info'>
                  <a href={p.toyLink} className='img-link'>
                    <img
                      className='img-responsive'
                      src={p.toyImage}
                      alt={p.toyDescription}
                    />
                  </a>
                </div>
                <div className='col-lg-12 col-md-12 col-sm-6 col-xs-6 product-info'>
                  <a href={p.toyLink} className='toy-link'>
                    {p.toyDescription}
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </React.Fragment>
    );
  }
}

export default ToyReviewList;
